import { Text } from "@chakra-ui/react";

export default function Joys2(){
    return(
        <>
        <Text className="text-format" style={{whiteSpace:"pre-line", alignContent:"center"}} >
        <br/>One thing that helped me in transition, was a small journal
        <br/>of small joys and small moments
        <br/>affirmations
        <br/>the usual kind of thing.
        <br/>
        <br/>Be an example to yourself,
        <br/>find some time, words, or kindness that you are willing to remember
        <br/>and record it.
        <br/>
        <br/>Be an example for others,
        <br/>in the moments when you can,
        <br/>And share it.
        </Text>
        </>
    )
}